// Iter 643 — Format kertas per file/versi mockup Shopee. Kosong = Format Belum Dipastikan.
import React from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const FORMAT_LABEL = { A5L: "A5 Landscape", A4P: "A4 Portrait", A4L: "A4 Landscape" };
export const formatLabel = (f) => FORMAT_LABEL[f] || "Format Belum Dipastikan";

export const setPaperFormat = (fileIds, paperFormat) =>
  axios.post(`${API}/shopee/files/paper-format`, { file_ids: fileIds, paper_format: paperFormat }, { withCredentials: true });

export function PaperFormatToggle({ value, onChange, disabled, tid }) {
  return <div className="pf-toggle" role="radiogroup" aria-label="Format kertas" data-testid={tid}>
    {Object.entries(FORMAT_LABEL).map(([k, lb]) => <button key={k} type="button" role="radio" aria-checked={value === k}
      className={`pf-opt${value === k ? " active" : ""}`} disabled={disabled} onClick={() => onChange(k)}
      data-testid={`${tid}-${k.toLowerCase()}`}>{lb}</button>)}
  </div>;
}

export function FormatBadge({ value, tid }) {
  return <span className={`pf-badge pf-${value ? value.toLowerCase() : "unknown"}`} data-testid={tid}>{formatLabel(value)}</span>;
}
